import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/sections/HeroSection';
import { StoriesViewer } from '../components/sections/StoriesViewer';
import { MarketsSection } from '../components/sections/ServicesSection';
import { ShowcaseSection } from '../components/sections/ShowcaseSection';
import { CTASection } from '../components/sections/CTASection';
import { VideoSection } from '../components/sections/VideoSection';

export default function HomePage() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <StoriesViewer />
        <VideoSection />
        <MarketsSection />
        <ShowcaseSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
